import React from 'react';

import { DropdownField } from '@components/FormFields';
import { DAYS, MONTHS, YEARS } from '@utils/dates';

interface DateOfBirthFieldProps {
  disableDobInput: boolean;
  error?: string;
}

const DateOfBirthField = ({ error, disableDobInput }: DateOfBirthFieldProps) => {
  return (
    <>
      <div className="dob-container mb-12 mt-24 flex items-center">
        <div className="font-sans text-body-sm font-bold uppercase text-primary-red">Birthday</div>
        <div className="ml-12 h-2 flex-1 bg-primary-red"></div>
      </div>
      <div className="flex items-center space-x-6">
        <div className="w-5/12">
          <DropdownField
            name="month"
            options={MONTHS}
            placeholder="Month"
            isDisabled={disableDobInput}
          />
        </div>
        <div className="w-3/12">
          <DropdownField name="day" options={DAYS} placeholder="Day" isDisabled={disableDobInput} />
        </div>
        <div className="w-4/12">
          <DropdownField
            name="year"
            options={YEARS}
            placeholder="Year"
            isDisabled={disableDobInput}
          />
        </div>
      </div>
      {error && <div className="mt-6 text-body-sm text-primary-red">{error}</div>}
    </>
  );
};

export default DateOfBirthField;
